export default {
  buttons: {
    cancel: "取消",
    dismiss: "關閉",
    add_waypoint: "加入目的地"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "里"
    }
  },
  search: {
    title: "搜尋",
    placeholder: "輸入地點",
    enter_location: "輸入地點",
    help: {
      inactive: "搜尋"
    }
  },
  filters: {
    title: "篩選",
    amenities: {
      title: "服務及設施"
    },
    fuels: {
      title: "燃油類別"
    }
  },
  directions: {
    title: "路線規劃",
    placeholder: {
      destination: "輸入地點",
      waypoint: "輸入地點"
    },
    route: {
      title: "路線選項",
      avoid_tolls: "避免收費道路",
      avoid_highways: "避免高速公路",
      title_corridor: "與油站的距離"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# 日} other {# 天}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# 分鐘} other {# 分鐘}}\
`,
    button: "搜尋"
  },
  locations: {
    title: "位置",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} 由 {place}"
  },
  info_window: {
    title: "油站詳情",
    services: "服務及設施",
    nearby: "附近",
    opening_hours: {
      title: "開放及關閉時間",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "最近一次更新",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "路線規劃"
  },
  fuels: {
    autogas_lpg: "石油氣",
    fuelsave_midgrade_gasoline: "Shell FuelSave 汽油",
    fuelsave_regular_diesel: "Shell FuelSave 柴油",
    premium_gasoline: "Shell V-Power"
  },
  amenities: {
    air_and_water: "空氣",
    atm: "自動櫃員機",
    austrian_highway_sticker: "奧地利公路貼紙",
    bank_note_acceptor: "存款櫃員機",
    bottled_gas: "BBQ汽缸丙烷更換",
    cafe: "餐廳",
    carwash: "洗車",
    clubsmart_card: "智能咭會藉",
    costa_express: "哥斯達黎加航空",
    credit_card_american_express: "信用卡 - 美國運通",
    credit_card_diners_club: "信用卡 - Diners Club",
    credit_card_mastercard: "信用卡 - 萬事達卡",
    credit_card_visa: "信用卡 - Visa",
    credit_card: "信用卡",
    czech_highway_sticker: "捷克公路貼紙",
    fleet_card_dkv: "車隊咭 - DKV",
    fleet_card_eni: "車隊咭 - Eni",
    fleet_card_esso: "車隊咭 - Esso",
    fleet_card_general: "車隊咭",
    fleet_card_uta: "車隊咭 - UTA",
    food_offerings: "食品種類",
    full_service: "全面服務/站員服務",
    guarded_car_park: "監管停泊",
    hgv_lane: "貨櫃車可使用",
    high_speed_diesel_pump: "高速柴油加油",
    hot_food: "熱食",
    hungarian_highway_sticker: "匈牙利公路貼紙",
    parking_lanes: "泊車徑",
    partner_loyalty_accepted: "已接受Partner Loyalty",
    pay_at_pump: "於油泵附款",
    quick_lubes: "快速換油",
    restaurant: "餐廳",
    self_service: "自助服務",
    service_bay: "超凡喜力換油中心",
    shell_club_smart_extra_card: "智能咭黃金會藉",
    shop: "便利店",
    shower: "淋浴",
    slovak_highway_sticker: "斯洛伐克公路貼紙",
    snack_food: "小食/快餐",
    standard_toilet: "洗手間",
    supermarket_fuel_discount: "燃油折扣",
    toilet: "洗手間",
    truck_parking: "貨櫃車停泊",
    truckport: "只限貨櫃車",
    twenty_four_hour: "24小時",
    vehicle_identity_system: "車輛驗證系統"
  },
  settings: {
    title: "設定",
    tooltip: "設定",
    distance_units: {
      title: "距離",
      km: "公里",
      miles: "里"
    },
    language: {
      title: "語言"
    }
  }
}
